import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2PairIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 47 47",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 47),
    children: [/*#__PURE__*/jsx("circle", {
      cx: "11.5",
      cy: "7",
      r: "6"
    }), /*#__PURE__*/jsx("path", {
      d: "M22 26.5a10.5 10.5 0 10-21 0V31h4.5L7 46h9l1.5-15H22z"
    }), /*#__PURE__*/jsx("circle", {
      cx: "35.5",
      cy: "7",
      r: "6"
    }), /*#__PURE__*/jsx("path", {
      d: "M26.5 31h3L31 46h9l1.5-15H46v-4.5a10.5 10.5 0 00-19.5-5.4"
    })]
  });
};

export { PM2PairIcon };
//# sourceMappingURL=pair.js.map
